import React from 'react';
import { useTranslation } from 'react-i18next';
import { AD_PLATFORMS } from './utils/utils';

interface Props {
  selectedPlatform: string | null;
  onSelect: (platform: string | null) => void;
}

export const AdPlatformSelector: React.FC<Props> = ({ selectedPlatform, onSelect }) => {
  const { t } = useTranslation();

  return (
    <>
      <label className="block text-gray-600 font-semibold mb-2">{t('ads.select_platform')}</label>
      <div className="flex flex-wrap">
        {AD_PLATFORMS.map((platform) => (
          <div
            key={platform.value}
            onClick={() => !platform.disabled && onSelect(platform.value)}
            className={`
              w-40 h-40 flex flex-col items-center justify-center border rounded-lg 
              relative m-2 transition duration-300 shadow-lg
              ${platform.disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : 'cursor-pointer'}
              ${
                selectedPlatform === platform.value
                  ? 'bg-green-600 text-white transform scale-105'
                  : 'bg-white text-gray-700 hover:shadow-xl'
              }
            `}
          >
            <span className="socialIcon">{React.createElement(platform.icon)}</span>
            <span
              className={`mt-2 font-medium ${selectedPlatform === platform.value ? 'text-gray-300' : ''}`}
            >
              {platform.name}
            </span>
            {platform.disabled && (
              <span className="absolute bottom-2 text-xs font-semibold text-orange-500">
                {t('common.coming_soon')}
              </span>
            )}
            {selectedPlatform === platform.value && !platform.disabled && (
              <span className="absolute bottom-2 text-xs font-semibold">
                {t('common.selected')}
              </span>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
